import { useContext, useEffect, useState } from 'react'
import Tabing from './tabing'
import { Link, useNavigate } from 'react-router'
import SettingIcon from '../../../../icons/setting'
// import BellIcon from '../../../../icons/bell'
import Grid1Icon from '../../../../icons/grid1'
import { GlobalContext } from '../../../../../context/Context'
// import PlusIcon from '../../../../icons/plus'
import { CircleUser, LogOut } from 'lucide-react'
import { CustomDropdown } from '../../../../ui/dropdown/CustomDropdown'
import { CustomDropdownButton } from '../../../../ui/dropdown/CustomDropdownButton'
import { CustomDropdownMenu } from '../../../../ui/dropdown/CustomDropdownMenu'
import { CustomDropdownMenuList } from '../../../../ui/dropdown/CustomDropdownMenuList'
// import MainPopup from '../../../../popup/main'
// import NotificationPanel from './notification'
import { useApiCall } from '../../../../custom-hooks/api-call'
import { Alert, Snackbar } from '@mui/material'
// import OprationHomePagePopup from '../../../../../pages/oprations/main/v2/index-v2'

const TopHeader = ({ topTabs, style, className }) => {
    let { state, dispatch } = useContext(GlobalContext);
    const route = useNavigate();
    const apiCall = useApiCall();
    const logOut = () => {
        localStorage.removeItem("tokenV3");
        localStorage.removeItem("userV3");
        dispatch({ type: 'USER_LOGOUT' })
    }
    const navigate = useNavigate()

    const accessRemove = () => {
        localStorage.removeItem('saleToken');
        route('/oprations/setting')
        dispatch({ type: 'SALE_LOGOUT' })
    }
    const [addUser, setAddUser] = useState(false);

    // NOTIFICATION 
    const [alertData, setAlertData] = useState({ isShow: false });
    const handleClose = () => {
        setAlertData({ isShow: false });
    };
    const onSuccess = (message) => { setAlertData({ isShow: true, type: "success", message: message }); getNotification(); };
    const onError = (message) => { setAlertData({ isShow: true, type: "error", message: message }); };
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const unreadCount = notifications.length;
    const [refreshLoad, setRefreshLoad] = useState(false)

    const markAsRead = async (id) => {
        setIsNotificationOpen(false);
        try {
            const apiData = JSON.stringify({ notification_id: id });
            const resp = await apiCall({ method: "post", url: "read-user-notification", data: apiData });
            onSuccess(resp?.respMsg || resp?.responseMessage || resp?.message || `Read Notification`)
        } catch (error) {
            onError(error?.respMsg || error?.responseMessage || error?.message || `Some Thing Went Wrong`)
        }
    };

    const markAsReadOnly = async (id) => {
        try {
            const apiData = JSON.stringify({ notification_id: id });
            const resp = await apiCall({ method: "post", url: "read-user-notification", data: apiData });
            onSuccess(resp?.respMsg || resp?.responseMessage || resp?.message || `Read Mark Notification`)
        } catch (error) {
            onError(error?.respMsg || error?.responseMessage || error?.message || `Some Thing Went Wrong`)
        }
    };

    const markAllAsRead = async () => {
        setIsNotificationOpen(false);
        try {
            const resp = await apiCall({ method: "post", url: "mark-all-read-notification" });
            onSuccess(resp?.respMsg || resp?.responseMessage || resp?.message || `Read All Notification`)
        } catch (error) {
            onError(error?.respMsg || error?.responseMessage || error?.message || `Some Thing Went Wrong`)
        }
    };

    const getNotification = async () => {
        // try {
        //     const resp = await apiCall({ method: "get", url: "get-user-notification-list" });
        //     setNotifications(resp?.userNotifications);
        //     setRefreshLoad(false);
        // } catch (error) {
        //     console.warn("Error : ", error)
        // }
    }

    useEffect(() => {
        getNotification();
    }, []);

    const [opration, setOpration] = useState(false);

    return (
        <>
            <div className={`${style.headerTop} ${className?.headerTop}`}>
                <Tabing topTabs={topTabs} style={style} className={className} />

                <div className={`${style.headerTop_right} ${className?.headerTop_right}`}>
                    {/* <div className={`${style.headerTop_right_access} ${className?.headerTop_right_access}`}>
                        <div
                            className="w-full cursor-pointer bg-red-600 text-white text-[12px] py-[10px] px-3 rounded-md hover:bg-red-700 transition shadow-sm"
                            onClick={() => { accessRemove() }}
                        >
                            Remove Access
                        </div>
                    </div>
                    {(state?.user?.user_role == 1 || state?.user?.user_role == 2 || state?.user?.user_role == 3) ?
                        <div className={`${style.headerTop_addButton} ${className?.headerTop_addButton}`} onClick={() => { setAddUser(true) }}>
                            <span className={`${style.headerTop_addBtn} ${className?.headerTop_addBtn}`}>
                                <PlusIcon size={'1em'} />
                            </span>
                        </div>
                        :
                        null
                    }

                    <div  onClick={() => { setOpration(true) }} className={`${style.headerTop_setting} ${className?.headerTop_setting}`}>
                        <span className={`${style.headerTop_settingBtn} ${className?.headerTop_settingBtn}`}>
                            <SettingIcon />
                        </span>
                    </div>

                    <div className={`${style.headerTop_notification} ${className?.headerTop_notification} !relative`}>
                        <span onClick={() => setIsNotificationOpen(!isNotificationOpen)} className={`${style.headerTop_notificationBtn} ${className?.headerTop_notificationBtn} cursor-pointer`}>
                            <BellIcon />

                            {unreadCount > 0 && (
                                <span className="absolute -top-1 -right-1 inline-flex items-center justify-center w-4 h-4 text-[10px] font-bold text-white bg-red-500 rounded-full">
                                    {unreadCount}
                                </span>
                            )}
                        </span>

                        <NotificationPanel
                            isOpen={isNotificationOpen}
                            notifications={notifications}
                            markAsRead={markAsRead}
                            markAllAsRead={markAllAsRead}
                            markAsReadOnly={markAsReadOnly}
                            refreshNotifications={() => { setRefreshLoad(true); getNotification(); }}
                            refreshLoad={refreshLoad}
                            onCloase={() => setIsNotificationOpen(!isNotificationOpen)}
                        />
                    </div>

                    <CustomDropdown className={`${style.headerTop_profile} ${className?.headerTop_profile}`} position="bottom-right">
                        <CustomDropdownButton arrow={false} className={`${style.headerTop_profileBtn} ${className?.headerTop_profileBtn} !p-0`}>
                            <img width={28} height={28} alt='Pic' src={state?.user?.profile_picture} />
                        </CustomDropdownButton>

                        <CustomDropdownMenu>
                            <CustomDropdownMenuList onClick={() => { navigate("/profile/my-data/overview") }}>
                                <div className={"d-flex align-items-center gap-1 !text-sm"}><CircleUser size={'1em'} /> Profile</div>
                            </CustomDropdownMenuList>
                            <CustomDropdownMenuList onClick={() => logOut()}>
                                <div className={"d-flex align-items-center gap-1 !text-sm"}><LogOut size={'1em'} /> LogOut</div>
                            </CustomDropdownMenuList>
                        </CustomDropdownMenu>
                    </CustomDropdown> */}

                    <div className={`${style.headerTop_setting} ${className?.headerTop_setting}`}>
                        <Link to="/config/departments" className={`${style.headerTop_settingBtn} ${className?.headerTop_settingBtn}`}>
                            <SettingIcon />
                        </Link>
                    </div>


                    <CustomDropdown className={`${style.headerTop_profile} ${className?.headerTop_profile}`} position="bottom-right">
                        <CustomDropdownButton arrow={false} className={`${style.headerTop_profileBtn} ${className?.headerTop_profileBtn} !p-0`}>
                            {/* <img width={28} height={28} alt='Pic' src={state?.user?.profile_picture} /> */}
                            <div className="flex items-center justify-center w-[28px] h-[28px] rounded-full overflow-hidden">
                                <p className='capitalize font-semi-bold text-base text-black'>
                                    {state?.user?.name?.split(" ")?.map((n, i) => n.charAt(0))}
                                </p>
                            </div>
                        </CustomDropdownButton>

                        <CustomDropdownMenu>
                            <CustomDropdownMenuList onClick={() => logOut()}>
                                <div className={"d-flex align-items-center gap-1 !text-sm"}><LogOut size={'1em'} /> LogOut</div>
                            </CustomDropdownMenuList>
                        </CustomDropdownMenu>
                    </CustomDropdown>
                    <div className={`${style.headerTop_nav} ${className?.headerTop_nav}`}>
                        <div className={`${style.headerTop_navBtn} ${className?.headerTop_navBtn}`}>
                            <Grid1Icon />
                        </div>
                    </div>
                </div>
            </div>


            {/* {addUser &&
                <MainPopup
                    onClose={() => { setAddUser(false); }}
                />
            }

            {opration && (
                <OprationHomePagePopup
                    onClosed={() => {
                        setTimeout(() => {
                            setOpration(false)
                        }, 200);
                    }}
                />
            )} */}

            <Snackbar
                open={alertData?.isShow}
                autoHideDuration={3000}
                onClose={handleClose}
            >
                <Alert
                    onClose={handleClose}
                    severity={alertData?.type}
                    variant="filled"
                    sx={{ width: "100%" }}
                >
                    {alertData?.message}
                </Alert>
            </Snackbar>
        </>
    )
}

export default TopHeader
